import { IconButton, Modal, Paper, Stack, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import CachedIcon from '@mui/icons-material/Cached';
import { DataGrid } from '@mui/x-data-grid';
import CustomPagination from '../../../components/customPagination';
import React, { useState } from 'react';
import { useGetShopifyLogsHandler } from '../dataHandlers/getShopifyLogsHandler';
import LogStatusChip from './LogStatusChip';

const ShopifyLogsModal = ({ open, onClose, store }) => {
  const [currentQuery, setCurrentQuery] = useState({ page: 1, limit: 10 });
  const [refreshIndex, setRefreshIndex] = useState(0);

  const handlePaginationChange = (page, limit) => {
    setCurrentQuery({ ...currentQuery, page: page, limit: limit });
  };

  const { logs, totalLogs, refetch, isLoading, isFetching } = useGetShopifyLogsHandler({
    searchQuery: {
      ...currentQuery,
      shopId: store.shop_id,
    },
  });

  const columns = [
    {
      field: 'log_level',
      headerName: 'Status',
      flex: 1,
      renderCell: ({ row }) => <LogStatusChip status={row.log_level} />,
    },
    {
      field: 'message',
      headerName: 'Log messages',
      flex: 5,
    },
  ];

  return (
    <Modal open={open} onClose={onClose}>
      <Paper
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 700,
          height: 700,
          padding: 16,
          outline: 'none',
        }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="h6">{store.shop_id}</Typography>
            <IconButton
              onClick={() => {
                setCurrentQuery({ page: 1, limit: 10 });
                setRefreshIndex((prev) => prev + 1);
                refetch();
              }}
            >
              <CachedIcon />
            </IconButton>
          </Stack>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Stack>
        <DataGrid
          key={refreshIndex}
          rows={logs}
          columns={columns}
          getRowId={(row) => row._id}
          paginationMode="server"
          loading={isLoading || isFetching}
          rowCount={totalLogs}
          getRowHeight={() => 'auto'}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          pageSizeOptions={[10, 25]}
          disableRowSelectionOnClick
          onPaginationModelChange={(model) => {
            handlePaginationChange(model.page + 1, model.pageSize);
          }}
          slots={{
            pagination: CustomPagination,
          }}
          sx={{
            height: 625,
            width: '100%',
            mt: 1,
            '& .MuiDataGrid-cell': {
              paddingTop: '15px',
              lineHeight: '1.5',
              paddingBottom: '15px',
            },
          }}
        />
      </Paper>
    </Modal>
  );
};

export default ShopifyLogsModal;
